﻿export interface IStates {
    states: Array<string>;
    isAKorNY: boolean;
    isCA: boolean;
    isMA: boolean;
    isDE: boolean;
    isMI: boolean;
    isMN: boolean;
    isNJ: boolean;
    isNY: boolean;
    isNC: boolean;
    isPA: boolean;
    isWI: boolean;
}

export class States implements IStates {
    public states: Array<string>;
    public isAKorNY: boolean;
    public isCA: boolean;
    public isMA: boolean;
    public isDE: boolean;
    public isMI: boolean;
    public isMN: boolean;
    public isNJ: boolean;
    public isNY: boolean;
    public isNC: boolean;
    public isPA: boolean;
    public isWI: boolean;
}